import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["size"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
// DO NOT EDIT IT MANUALLY

import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgRobot = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  props.width = undefined;
  props.height = undefined;
  var testId = 'icon-robot';
  var style = {};
  var isCustomSize = typeof size === 'number';
  if (isCustomSize) {
    style.width = size + 'px';
    style.height = size + 'px';
    if (!props.style) props.style = {};
    props.style.width = size + 'px';
    props.style.height = size + 'px';
  }
  return /*#__PURE__*/_jsx("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 24 24",
    "data-test-id": testId,
    ref: ref
  }, props), {}, {
    children: /*#__PURE__*/_jsx("path", {
      d: "M11.24 4.16v1.16h-.104c-.172 0-.863.152-1.2.264-1.74.578-3.158 1.817-3.994 3.49a6.9 6.9 0 0 0-.596 1.842l-.046.304-1.03.011-1.03.01v4.519h2v3.54l1.23 1.23 1.23 1.23h8.6l1.23-1.23 1.23-1.23v-3.54h2v-4.519l-1.03-.01-1.03-.011-.046-.304c-.278-1.823-1.472-3.603-3.114-4.641a8.6 8.6 0 0 0-1.476-.691c-.338-.112-1.029-.264-1.2-.264h-.104V3h-1.52zm1.8 2.7a5.13 5.13 0 0 1 2.556 1.362 5.5 5.5 0 0 1 1.548 2.738c.066.275.073.613.085 4.018l.014 3.718-.771.772-.771.772H8.299l-.771-.772-.771-.772.014-3.718c.012-3.405.019-3.743.085-4.018a5.5 5.5 0 0 1 1.541-2.732c.796-.771 1.69-1.221 2.803-1.412.397-.068 1.441-.043 1.84.044m-3.8 5.4V13h1.52v-1.48H9.24zm4 0V13h1.52v-1.48h-1.52z"
    })
  }));
});
export default SvgRobot;